export default __webpack_public_path__ + "static/media/laundry1-beforeA-480w.0d9816c5.webp";